"use strict";

export const cookiesClass = class {
  constructor() {
    this.banner = document.getElementById("consent-banner");
    this.form = document.getElementById("cookie-consent-form");
    this.consentIconLink = document.querySelector('.consent-icon a');

    this.acceptAllButton = document.getElementById("accept-all");
    this.acceptAllButton2 = document.getElementById("accept-all-2");
    this.acceptAnalyticsButton = document.getElementById("accept-analytics");
    this.rejectAllButton = document.getElementById("reject-all");
    this.saveConsentButton = document.getElementById("save-consent");

    this.cookiePreferencesKey = "cookie_preferences";
    this.gtmContainers = ['GTM-P3W9RWTC', 'GTM-5VHN4XV', 'GTM-KJ8G6JQ']; // Lista identyfikatorów GTM

    this.init();
  }

  init() {
    console.log("init");

    // Sprawdź, czy użytkownik już wybrał preferencje
    const preferences = this.getPreferences();

    if (preferences) {
      // Jeśli preferencje są zapisane, usuń klasę active (ukryj baner)
      this.hideConsentBanner();
    } else {
      // Jeśli brak preferencji, pokaż baner
      this.showConsentBanner();
    }

    // Synchronizuj formularz z zapisanymi preferencjami
    this.syncFormWithPreferences();

    // Dodaj event listener dla przycisków
    this.addEventListeners();

    //this.setDefaultConsent();

    this.setupTabs();
  }

  setDefaultConsent() {
    // Ustaw domyślne stany zgody dla każdego kontenera GTM

    window[`dataLayer`] = window[`dataLayer`] || [];
    window[`dataLayer`].push({
      'ad_storage': 'denied',
      'analytics_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'consent': 'revoke'

    });
  }

  addEventListeners() {
    this.acceptAllButton.addEventListener("click", () => {
      this.savePreferences({
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        consent: 'grant'
      });
      this.syncFormWithPreferences();
      this.hideConsentBanner();
    });

    this.acceptAllButton2.addEventListener("click", () => {
      this.savePreferences({
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        consent: 'grant'
      });
      this.syncFormWithPreferences();
      this.hideConsentBanner();
    });


    this.rejectAllButton.addEventListener("click", () => {
      this.savePreferences({
        ad_storage: "denied",
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        consent: 'revoke'
      });
      this.syncFormWithPreferences();
      this.hideConsentBanner();
    });

    this.saveConsentButton.addEventListener("click", () => {
      const preferences = this.getFormPreferences();
      this.savePreferences(preferences);
      this.hideConsentBanner();
    });

    // Dodanie obsługi kliknięcia w link do formularza
    if (this.consentIconLink) {
      this.consentIconLink.addEventListener("click", (event) => {
        event.preventDefault(); // Zapobiegamy domyślnemu przewinięciu strony
        this.toggleConsentBanner();
      });
    }
  }

  syncFormWithPreferences() {
    const preferences = this.getPreferences();

    if (preferences) {
      this.form.querySelector("input[name='analytics']").checked = preferences.analytics_storage === "granted";
      this.form.querySelector("input[name='advertising']").checked = preferences.ad_storage === "granted";
    }
  }

  showConsentBanner() {
    this.banner.classList.add("active");
  }

  hideConsentBanner() {
    this.banner.classList.remove("active");
  }

  toggleConsentBanner() {
    // Przełącza widoczność formularza zgód
    if (this.banner.classList.contains("active")) {
      this.hideConsentBanner();
    } else {
      this.showConsentBanner();
    }
  }

  getPreferences() {
    // Pobierz preferencje z localStorage
    const storedPreferences = localStorage.getItem(this.cookiePreferencesKey);
    return storedPreferences ? JSON.parse(storedPreferences) : null;
  }

  savePreferences(preferences) {
    // Zapisz preferencje w localStorage
    localStorage.setItem(this.cookiePreferencesKey, JSON.stringify(preferences));
    console.log("Zapisane preferencje:", preferences);

    this.updateConsentInDataLayer(preferences);
    this.updateGtagConsent(preferences);
  }

  updateGtagConsent(preferences) {
    if (typeof gtag === "function") {
      gtag("consent", "update", {
        ad_storage: preferences.ad_storage,
        analytics_storage: preferences.analytics_storage,
        ad_user_data: preferences.ad_user_data,
        ad_personalization: preferences.ad_personalization,
      });
    } else {
      console.warn("gtag is not available. Consent update skipped.");
    }
  }

  getFormPreferences() {
    // Odczytaj preferencje z formularza
    const analytics = this.form.querySelector("input[name='analytics']").checked;
    const advertising = this.form.querySelector("input[name='advertising']").checked;

    return {
      ad_storage: advertising ? "granted" : "denied",
      analytics_storage: analytics ? "granted" : "denied",
      ad_user_data: advertising ? "granted" : "denied",
      ad_personalization: advertising ? "granted" : "denied",
      consent: advertising ? "grant" : "revoke",
    };
  }

  updateConsentInDataLayer(preferences) {

    window[`dataLayer`] = window[`dataLayer`] || [];
    window[`dataLayer`].push({
      event: 'consent_update',
      consent: {
        ad_storage: preferences.ad_storage,
        analytics_storage: preferences.analytics_storage,
        ad_user_data: preferences.ad_user_data,
        ad_personalization: preferences.ad_personalization,
      },
    });

    if (typeof fbq === "function") {
      fbq("consent", preferences.consent);
    }


  }

  setupTabs() {
    const tabButtons = document.querySelectorAll('.tabs-buttons a');
    const tabContents = document.querySelectorAll('.tab-content');
    const personalizeButtons = document.querySelectorAll('.personalizuj-button');

    tabButtons.forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        // Usunięcie klasy 'active' ze wszystkich przycisków i zakładek
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Dodanie klasy 'active' do wybranego przycisku
        this.classList.add('active');

        // Pobranie id docelowej zakładki
        const targetId = this.getAttribute('href').substring(1);

        // Dodanie klasy 'active' do wybranego kontenera treści
        document.getElementById(targetId).classList.add('active');
      });
    });

    personalizeButtons.forEach(button => {
      button.addEventListener('click', function () {
        const targetId = this.getAttribute('attr-show');

        // Usunięcie klasy 'active' ze wszystkich zakładek i przycisków
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));

        // Dodanie klasy 'active' do wybranego kontenera treści
        document.getElementById(targetId).classList.add('active');

        // Znalezienie odpowiedniego przycisku i nadanie mu klasy 'active'
        tabButtons.forEach(btn => {
          if (btn.getAttribute('href') === `#${targetId}`) {
            btn.classList.add('active');
          }
        });
      });
    });
  }
};